import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_GET, llamadaAPI_GET_conAccessToken } from '../../SQL';
import { TratamientoDeParametroParaURI } from '../../Varios';

export const function_VEN_Reservas_MercadoPago_ObtenerToken = async (codigoCompania) => {
    let accessToken = "";

    switch (codigoCompania) {
        case '000':
            accessToken = "TEST-3733564526381494-060510-bcd5092d4cc1447fcf69ce3804b37591-1391068111";
            break;
        case '301':
            accessToken = "APP_USR-8955917039606476-080415-34d335353df219af429d59df1218f5cb-1146773914";
            break;
        case '302':
            accessToken = "APP_USR-7709404392733582-081413-91433fb4dcc47a9423cfcd23f1a1b49a-1408450585";
            break;
        case '303':
            accessToken = "TEST-3733564526381494-060510-bcd5092d4cc1447fcf69ce3804b37591-1391068111";
            break;
        case '304':
            accessToken = "APP_USR-2755206353225285-072415-0f0d2999d8cfe40a2513e9fdad8c3709-1423814365";
            break;
        case '305':
            accessToken = "TEST-3733564526381494-060510-bcd5092d4cc1447fcf69ce3804b37591-1391068111";
            break;
        case '306':
            accessToken = "";
            break;
        case '307':
            accessToken = "";
            break;
        default:
            accessToken = "APP_USR-7942341063824579-071113-768904f5e7a6fdc5a671f53d2a475183-384301024";
    }

    return accessToken
}

export const function_VEN_Reservas_MercadoPago_CheckDePago = async (codigoCompania) => {
    const NombreFuncion = "function_VEN_Reservas_MercadoPago_CheckDePago"    
    const accessToken = await function_VEN_Reservas_MercadoPago_ObtenerToken(codigoCompania);

    try {
        const resulData = await llamadaAPI_GET_conAccessToken("https://api.mercadopago.com/merchant_orders", accessToken);

        return resulData
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_MercadoPago_CheckDePagoIndividual = async (codigoCompania, preference_id) => {
    const NombreFuncion = "function_VEN_Reservas_MercadoPago_CheckDePago"    
    const accessToken = await function_VEN_Reservas_MercadoPago_ObtenerToken(codigoCompania);

    try {
        const resulData = await llamadaAPI_GET_conAccessToken("https://api.mercadopago.com/merchant_orders?preference_id=" + preference_id, accessToken);

        return resulData
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};